import { Service } from "./service.model";

export class PriceDVGT {
    code: string;
    name: string;
    vSEOracleCode: string;
    serviceId: number;
    totalPrice: number;
    isAgree: boolean;
    priceServiceCode: string;
}